module.exports = __webpack_public_path__ + "static/media/download.fa627835.svg";